
let BASE_URL = '';

switch (process.env.MODE) {
    case 'LOCAL':
        BASE_URL = 'https://icedalnusa.xyz/';
        break;

    case 'DEVELOPMENT':
        BASE_URL = 'https://dev.icedalnusa.com/';
        break;

    case 'PRODUCTION':
        BASE_URL = 'https://icedalnusa.com/';
        break;
}

const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const shortenedMonth = ["Jan", 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const s3Path = process.env.S3PATH;

export {
    BASE_URL, month, shortenedMonth, s3Path
}

